import React from 'react';
import { Typography, Descriptions, Skeleton, Card } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export interface DetailItem {
  label: string;
  value: React.ReactNode;
}

export interface RenderDetailsProps {
  data: DetailItem[];
  columns?: number; // number of columns in a row
  isLoading?: boolean;
}

const RenderDetails = ({ data, columns = 2, isLoading = false }: RenderDetailsProps) => {
  const { t } = useTranslation();

  return isLoading ? (
    <Skeleton active paragraph={{ rows: 4 }} />
  ) : (
    <Card bodyStyle={{ padding: 0 }}>
      <Descriptions column={columns} bordered>
        {data.map((item, index) => (
          <Descriptions.Item key={index} label={t(item.label)}>
            {item.value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </Card>
  );
};

export default RenderDetails;
